import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Offres from '../views/Offres.vue'
import ConditionsVentes from '../views/ConditionsVentes.vue'
import SingleOffer from '../views/SingleOffre.vue'
import About from '../views/About.vue'
// import x5GMaps from 'x5-gmaps'

// Vue.use(x5GMaps, 'AIzaSyD9uWo8uF06knE_qIUO1ii6XPF_KEAsvsk')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/conditions-vente',
    name: 'ConditionsVente',
    component: ConditionsVentes
  },
  {
    path: '/single-offer/:id',
    name: 'SingleOffer',
    component: SingleOffer
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  { path: '/offres', name: 'Offres', component: Offres },
]

const router = new VueRouter({
  routes
})

export default router
